import { useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteVehiculo } from '../../helpers/api_helper';

const useDeleteVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const deleteVehiculoHook = async (PATENT) => {
        setLoading(true);
        setError(null);
        try {
            const params = { tenantId, empresa, departamento };
            const response = await deleteVehiculo(empresa, PATENT, params);
            return { success: true, data: response };
        } catch (err) {
            const errorMessage = `Failed to delete vehiculo: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { deleteVehiculo: deleteVehiculoHook, loading, error };
};

export default useDeleteVehiculo;
